<template>
  <div :class="modoCompacto ? '' : 'login-shell'" v-if="mostrarInicio">
    <div class="login-card">
      <div class="login-brand">
        <img src="img/maxica-logo.jpg" alt="Maxica" />
      </div>

      <h1>Ingresa a Maxica</h1>
      <p class="login-copy">
        Solo necesitas tu numero de telefono. Con tu perfil puedes revisar
        pedidos y reclamar MaxiPuntos.
      </p>

      <b-field label="Telefono">
        <b-input
          icon="phone-outline"
          type="tel"
          placeholder="Ej. 312 345 6789"
          v-model="form.telefono"
          @keyup.native.enter="iniciarSesion"
        />
      </b-field>

      <transition name="fade">
        <div v-if="necesitaRegistro" class="registro-suave">
          <p>
            No encontramos ese telefono. Crea tu perfil para comprar y guardar
            tu historial.
          </p>
          <b-field label="Nombre completo">
            <b-input
              icon="account-outline"
              type="text"
              placeholder="Tu nombre"
              v-model="form.nombre"
              @keyup.native.enter="iniciarSesion"
            />
          </b-field>
          <label class="terms-check">
            <input type="checkbox" v-model="form.aceptaTerminos" />
            <span>
              Al registrarme acepto los
              <a
                href="https://maxica.com.co/#/politicas"
                target="_blank"
                rel="noopener"
              >
                terminos y condiciones
              </a>
              de Maxica.
            </span>
          </label>
        </div>
      </transition>

      <div v-if="errorLogin" class="mensaje-error-login">
        <i class="mdi mdi-alert-circle-outline"></i>
        {{ errorLogin }}
      </div>

      <div class="botones-login">
        <button class="btn-primary-login" :disabled="cargando" @click="iniciarSesion">
          <i :class="cargando ? 'mdi mdi-loading mdi-spin' : 'mdi mdi-check'"></i>
          {{ textoBoton }}
        </button>
        <button class="btn-ghost-login" @click="menuClose">Cancelar</button>
      </div>

      <button class="support-link" type="button" @click="abrirSoporte">
        <i class="mdi mdi-whatsapp"></i>
        Necesito ayuda con mi cuenta
      </button>
    </div>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";

export default {
  name: "InicioSesion",
  mixins: [NotificacionesMixin],

  props: {
    mostrarInicio: {
      type: Boolean,
      default: true,
    },
    modoCompacto: {
      type: Boolean,
      default: false,
    },
    colorFondo: {
      type: String,
      default: "#111111",
    },
  },
  data: () => ({
    form: {
      telefono: "",
      nombre: "",
      aceptaTerminos: false,
    },
    necesitaRegistro: false,
    cargando: false,
    errorLogin: "",
  }),
  computed: {
    textoBoton() {
      if (this.cargando) return "Validando";
      return this.necesitaRegistro ? "Crear perfil e ingresar" : "Ingresar";
    },
  },
  mounted() {
    document.title = "Ingresar a Maxica";
  },
  methods: {
    menuClose() {
      this.$emit("menuClose");
    },
    abrirSoporte() {
      window.open(
        "https://wa.me/573125798515?text=Necesito%20ayuda%20con%20mi%20perfil%20Maxica",
        "_blank"
      );
    },
    normalizarTelefono(valor) {
      let digitos = String(valor || "").replace(/\D+/g, "");
      if (digitos.length > 10 && digitos.startsWith("57")) {
        digitos = digitos.slice(-10);
      }
      return digitos;
    },
    validarFormulario() {
      const telefono = this.normalizarTelefono(this.form.telefono);
      if (!/^3\d{9}$/.test(telefono)) {
        this.errorLogin = "Escribe un celular colombiano valido.";
        return null;
      }

      if (this.necesitaRegistro) {
        if (!this.form.nombre.trim()) {
          this.errorLogin = "Escribe tu nombre para crear el perfil.";
          return null;
        }
        if (!this.form.aceptaTerminos) {
          this.errorLogin = "Debes aceptar los terminos y condiciones.";
          return null;
        }
      }

      this.errorLogin = "";
      return telefono;
    },
    iniciarSesion() {
      const telefono = this.validarFormulario();
      if (!telefono || this.cargando) return;

      this.cargando = true;
      const payload = {
        accion: "iniciar_sesion_telefono",
        usuario: {
          telefono,
          nombre: this.necesitaRegistro ? this.form.nombre.trim() : "",
          aceptaTerminos: this.form.aceptaTerminos,
        },
      };

      HttpService.obtenerConConsultas("usuarios.php", payload)
        .then((resultado) => {
          if (resultado && resultado.estado) {
            this.errorLogin = "";
            this.mostrarNotificacion("success", "Bienvenido a Maxica.");
            this.$emit("login", resultado);
            return;
          }

          if (resultado && resultado.necesitaRegistro) {
            this.necesitaRegistro = true;
            this.form.telefono = resultado.telefono || telefono;
            this.errorLogin = "";
            return;
          }

          this.errorLogin =
            (resultado && resultado.mensaje) ||
            "No pudimos validar este telefono. Intenta de nuevo.";
        })
        .catch(() => {
          this.errorLogin = "No pudimos conectar con Maxica. Intenta de nuevo.";
        })
        .finally(() => {
          this.cargando = false;
        });
    },
  },
};
</script>

<style scoped>
.login-shell {
  min-height: 100%;
  padding: 18px;
}

.login-card {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  background: #ffffff;
  color: #181818;
  border: 1px solid #e6e1dc;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.18);
  font-family: "Poppins", Arial, sans-serif;
}

.login-brand {
  width: 168px;
  height: 58px;
  margin: 0 auto 18px;
  background: #080808;
  border-radius: 7px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-brand img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.login-card h1 {
  margin: 0 0 8px;
  font-size: 1.45rem;
  line-height: 1.2;
  font-weight: 800;
  color: #111111;
  text-align: center;
}

.login-copy {
  margin: 0 0 20px;
  color: #5f5a55;
  font-size: 0.95rem;
  line-height: 1.45;
  text-align: center;
}

.registro-suave {
  margin: 14px 0;
  padding: 14px;
  background: #faf7f2;
  border: 1px solid #eadfd2;
  border-radius: 7px;
}

.registro-suave p {
  margin: 0 0 12px;
  color: #4b4742;
  font-size: 0.92rem;
  line-height: 1.4;
}

.terms-check {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: #4b4742;
  font-size: 0.88rem;
  line-height: 1.35;
}

.terms-check input {
  margin-top: 2px;
  accent-color: #111111;
}

.terms-check a {
  color: #111111;
  font-weight: 700;
  text-decoration: underline;
}

.mensaje-error-login {
  color: #8f1d2c;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 7px;
  padding: 10px 12px;
  font-size: 0.92rem;
  font-weight: 600;
  margin: 12px 0 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.botones-login {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 18px;
}

.btn-primary-login,
.btn-ghost-login,
.support-link {
  min-height: 44px;
  border-radius: 6px;
  font-family: "Poppins", Arial, sans-serif;
  font-weight: 700;
  cursor: pointer;
}

.btn-primary-login {
  border: 1px solid #111111;
  background: #111111;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-primary-login:disabled {
  opacity: 0.65;
  cursor: wait;
}

.btn-ghost-login {
  border: 1px solid #d7d0c8;
  background: #ffffff;
  color: #292929;
}

.support-link {
  width: 100%;
  margin-top: 12px;
  border: 0;
  background: transparent;
  color: #315a3d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-size: 0.9rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.login-card /deep/ .label {
  color: #262626;
  font-weight: 700;
}

@media (max-width: 520px) {
  .login-card {
    padding: 20px;
  }

  .botones-login {
    grid-template-columns: 1fr;
  }
}
</style>
